/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { withClient } from 'fierry/react';
import uuid from 'fierry/type/uuid';

import SectorVariant from 'solis/data/sector.generator/variant';

import Hex from 'solis/type/hex';


export default withClient(class
{
  constructor ({ count })
  {
    this.count = count;

    const start = performance.now();

    this.sectors = this.generateVariants().map(variant =>
    {
      return { id: uuid(), zones: variant.toArray() };
    });

    const elapsed = performance.now() - start;

    console.log('Sectors generated: ', this.sectors.length, ' in ', elapsed.toFixed(2), 'ms');
  }


  generateVariants ()
  {
    const seed = this.getSeed();

    let source = new Map([[ seed.getKey(), seed ]]);
    let target = new Map();

    let size = seed.size();

    while (size < this.count)
    {
      for (const variant of source.values())
      {
        for (const neighbor of variant.getVariantNeighbors())
        {
          const candidate = variant.advance(neighbor);

          if (!target.has(candidate.getKey()))
          {
            target.set(candidate.getKey(), candidate);
          }
        }
      }

      source = target;
      target = new Map();

      ++size;
    }

    return [ ...source.values() ];
  }


  getSeed ()
  {
    return new SectorVariant([ new Hex(0, 0), new Hex(1, 0) ]);
  }


  getSectors ()
  {
    return this.sectors;
  }


});
